import { useNavigate } from 'react-router-dom';
import { categories } from '@/mocks/data';

export default function CategorySection() {
  const navigate = useNavigate();

  return (
    <section className="w-full bg-background-100 py-10 md:py-14">
      <div className="max-w-[1400px] mx-auto px-4 md:px-6">
        <div className="text-center mb-8">
          <h2 className="text-xl md:text-2xl font-bold font-heading text-foreground-950">
            <i className="ri-apps-2-line text-accent-500 mr-2"></i>
            视频分类
          </h2>
          <p className="text-sm text-foreground-500 mt-1">按分类浏览你感兴趣的爆料内容</p>
        </div>

        <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4">
          {categories.map((cat) => (
            <div
              key={cat.id}
              onClick={() => { navigate(`/category/${cat.slug}`); window.scrollTo({ top: 0, behavior: 'smooth' }); }}
              className="bg-background-50 border border-background-200/70 rounded-lg p-5 hover:border-primary-500/40 transition-all cursor-pointer group"
            >
              <div className="w-10 h-10 flex items-center justify-center rounded-lg bg-accent-100 text-accent-600 mb-3 group-hover:bg-accent-500 group-hover:text-white transition-colors">
                <i className={`${cat.icon} text-lg`}></i>
              </div>
              <h3 className="font-semibold text-foreground-950 text-sm md:text-base mb-1 whitespace-nowrap">
                {cat.name}
              </h3>
              <p className="text-xs text-foreground-500">{cat.count} 个视频</p>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}